export type TListener = [HTMLElement | Window, string, (e: any) => any, boolean | AddEventListenerOptions]

export class EventListenerManager {
    private listeners: TListener[] = []

    public add(arr: TListener) {
        this.listeners.push(arr)
        arr[0].addEventListener(arr[1], arr[2], arr[3] ?? null)
    }

    public dispose() {
        this.listeners.forEach(obj => obj[0].removeEventListener(obj[1], obj[2], obj[3]))
    }
}
